(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
    const syncAcceleratedCheckoutHeight = (acceleratedCheckoutBlock) => {
      const productFormButtons = acceleratedCheckoutBlock.closest('.product-form-buttons');
      if (!productFormButtons) return;

      const addToCartButton = productFormButtons.querySelector('.add-to-cart-button');
      if (!addToCartButton) return;

      const addToCartButtonHeight = Math.round(addToCartButton.getBoundingClientRect().height);
      if (!addToCartButtonHeight) return;

      acceleratedCheckoutBlock.style.setProperty('--accelerated-checkout-button-height', `${addToCartButtonHeight}px`);
    };

    const syncAllAcceleratedCheckoutHeights = () => {
      const acceleratedCheckoutBlocks = document.querySelectorAll(
        '.accelerated-checkout-block[data-accelerated-checkout-height-sync="true"]',
      );

      acceleratedCheckoutBlocks.forEach((acceleratedCheckoutBlock) => {
        syncAcceleratedCheckoutHeight(acceleratedCheckoutBlock);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncAllAcceleratedCheckoutHeights, { once: true });
    } else {
      syncAllAcceleratedCheckoutHeights();
    }

    window.addEventListener('load', syncAllAcceleratedCheckoutHeights, { once: true });
    window.addEventListener('resize', syncAllAcceleratedCheckoutHeights);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["related-products"] && !Shopify.designMode) return;
  try {
    (() => {
    const relatedProductsBlocks = document.querySelectorAll('.related-products-block');

    relatedProductsBlocks.forEach((relatedProductsBlock) => {
      if (relatedProductsBlock.dataset.hoverValueBound === 'true') return;

      const defaultValue = relatedProductsBlock.dataset.defaultValue || '';
      const valueTextElements = relatedProductsBlock.querySelectorAll('.related-products-block__value-text');
      const optionLinks = relatedProductsBlock.querySelectorAll('.related-products-block__link[data-related-value]');

      if (valueTextElements.length === 0 || optionLinks.length === 0) return;

      const setValueText = (nextValue) => {
        const resolvedValue = nextValue && nextValue.trim() ? nextValue : defaultValue;

        valueTextElements.forEach((valueTextElement) => {
          valueTextElement.textContent = resolvedValue;
        });
      };

      optionLinks.forEach((optionLink) => {
        const hoverValue = optionLink.dataset.relatedValue || defaultValue;

        optionLink.addEventListener('mouseenter', () => {
          setValueText(hoverValue);
        });

        optionLink.addEventListener('focus', () => {
          setValueText(hoverValue);
        });

        optionLink.addEventListener('mouseleave', () => {
          setValueText(defaultValue);
        });

        optionLink.addEventListener('blur', () => {
          setValueText(defaultValue);
        });
      });

      relatedProductsBlock.dataset.hoverValueBound = 'true';
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
